<template lang="pug">
    v-container.exam-basic-container
        v-container.timer
            v-row 
                Timer(:date='dateDeadline' :bmins='true' :bsecs='true' @deadline='warnDeadline = $event')
            v-row.navexams-btn-container
                v-col
                    v-btn.navexams-btn(color='primary' @click='warnContinue = true' :disabled = 'continueBtn') Continuar
                v-col
                    v-btn.navexams-btn(color='error' @click='warnFinalize = true' :disabled = 'finalizeBtn') Finalizar       
        v-overlay(v-model='warnInit' opacity='1')
            v-dialog(v-model='warnInit' max-width='650px'  persistent hide-overlay)
                v-card
                    v-card-title
                        span.headline Advertencia
                    v-card-text.text-warn
                        v-container
                            v-row 
                            p
                            | ¡Estás a punto de comenzar el examen, no podrás pausar, hasta que este finalizado!
                            br
                            v-row
                                v-col
                                    v-btn(color='error' text='' @click='backHome()') Volver al Home
                                v-col
                                    v-btn(color='success' text='' @click='initExam()') Continuar    
        v-dialog(v-model='warnContinue' max-width='500px')
          v-card
            v-card-title
              span.headline Advertencia
            v-card-text.text-warn
              v-container
                v-row 
                p
                | ¿ Estás seguro que deseas continuar? 
                p 
                | Una vez aceptado no podrás volver.
                br
                v-row
                    v-col
                        v-btn(color='error' text='' @click='warnContinue = false') Cancelar
                    v-col
                        v-btn(color='success' text='' @click='nextQuestions()') Continuar
        v-dialog(v-model='warnFinalize' max-width='500px')
          v-card
            v-card-title
              span.headline Advertencia
            v-card-text.text-warn
              v-container
                v-row
                p
                | Estás a punto de finalizar el examen. 
                p
                | ¿ Estás seguro que deseas continuar y cerrarlo? 
                p 
                | Una vez aceptado no podrás volver.
                br
                v-row
                    v-col
                        v-btn(color='error' text='' @click='warnFinalize = false') Cancelar
                    v-col
                        v-btn(color='success' text='' @click='finalize()') Continuar
        v-dialog(v-model='warnDeadline' max-width='500px' persistent)
          v-card
            v-card-title
              span.headline Advertencia
            v-card-text.text-warn
              v-container
                v-row 
                p
                | ¡El tiempo se ha agotado!
                br
                v-row
                    v-col
                        v-btn(color='success' text='' @click='finalize()') Finalizar
        v-container.intructions
            v-card
                v-card-title Instructions
                v-card-text
                    | Read the following sententences and select the option that best completes each one.
        v-container.intructions
            v-row.advance {{ Math.ceil(value_progress) }}% - {{ rate_progress }}
            v-progress-linear( :active='active_progress' background-opacity='0.3' buffer-value='100'  :value='value_progress' color='light-blue' reactive='')



        v-container.exam-container
            form
                template(v-for='(q,i) in renderQuestions')
                    v-row
                        v-col
                            v-row
                                | {{ q.desc }}
                            v-row
                                template(v-if='q.ans_type == 1')
                                    v-radio-group(v-model='answers[`${q.id}`]')
                                        v-radio(v-for='(a,ia) in q.answers' :key='ia' :label='`${a.desc}`' :value='ia')
                                template(v-if='q.ans_type == 2')
                                    v-radio-group(v-model='answers[`${q.id}`]' :multiple='true')
                                        v-radio(v-for='(a,ia) in q.answers' :key='ia' :label='`${a.desc}`' :value='ia')
</template>

<script>
import { config } from '../config.js'
import Timer from '../components/Timer'

export default {
    components:
    {
        Timer
    },
    created () {
    },
    mounted(){
      console.log('Props: ', this.$route.query.id);
      this.$emit("loadingEvent", true);
      if(this.$route.query.id){
        this.exam_id = this.$route.query.id;

        let user = JSON.parse(localStorage.getItem('user'));

        this.axios.get(`${config.serviceUri}exams?auth=${user.id}&idExam=${this.exam_id}`)
            .then( (response) => {
                console.log('Exam Auth: ', response.data);
                let auth = response.data.payload;
                if(auth){
                    this.warnInit = true;
                }else{
                    console.log('You are not authorized to perfom this test')
                    this.$emit("loadingEvent", false);
                    this.$router.push({ name: 'home' });  
                }
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.$emit("loadingEvent", false);
                this.$router.push({ name: 'home' })
            });
      }else{
        this.$emit("loadingEvent", false);
        this.$router.push({ name: 'home' });
      }
    },
    data: () => ({
        exam: {},
        active_progress: false,
        value_progress: 0,
        rate_progress: '',
        exam_id: '',
        dateDeadline: '',
        continueBtn: false,
        finalizeBtn: true,
        counter: 5,
        lastIndex: 0, 
        total_questions: 0,
        renderQuestions: [],
        warnContinue: false,
        warnFinalize: false,
        warnDeadline: false,
        warnInit: false,
        questions:[
        ],
        answers:{}
    }),

    methods: {
        initialize () {
            let _this = this;
            console.log('Initializate exam')

            this.axios.get(`${config.serviceUri}exams?id=${this.exam_id}`)
            .then( (response) => {
                console.log('Succes request: ',response.data);
                _this.exam = response.data.payload;
                _this.loading = false;

                _this.questions = [];

                _this.exam.questions.forEach( q => {
                    _this.questions = _this.questions.concat(q.questions);
                })
                _this.total_questions = _this.questions.length;
                _this.active_progress = true;
                _this.getRenderQuestions();
                _this.deadline();
            })
            .catch( (error) => {
                console.log('Error: ', error);
                _this.$emit("loadingEvent", false);
                _this.$router.push({ name: 'home' })
            });
        
            
        },
        deadline() {
            console.log('Reload Function')
            if(!this.dateDeadline){
                var dt = new Date();
                if(this.exam.time){
                    dt.setMinutes( dt.getMinutes() + Number(this.exam.time) );    
                } else{
                    dt.setMinutes( dt.getMinutes() + 1 ); 
                }
                this.dateDeadline = dt;
            }
            this.$emit("loadingEvent", false);
        },
        getRenderQuestions(startIndex = 0){
            let endIndex = startIndex + this.counter;
            
            if(this.questions.slice(startIndex, endIndex).length > 0){
                this.renderQuestions = this.questions.slice(startIndex, endIndex);
                this.renderQuestions.sort(() => Math.random() - 0.5);
                console.log('questions to render' , this.renderQuestions)
                this.renderQuestions.forEach( q => q.answers.sort(() => Math.random() - 0.5) );
                this.lastIndex = endIndex;
            }else{
                this.continueBtn = true;
                this.finalizeBtn = false;
            }

            this.value_progress = (this.lastIndex * 100)/ this.total_questions;
            this.rate_progress = `${this.lastIndex}/${this.total_questions}`;
        },
        nextQuestions(){
            this.getRenderQuestions(this.lastIndex);
            this.warnContinue = false;
        },
        backHome(){
            this.$router.push({ name: 'home' })
            this.$emit("loadingEvent", false);
        },
        initExam(){
            this.$emit("loadingEvent", true);
            this.initialize();
            this.warnInit = false;
        },
        saveResults(){

            debugger;
            let user = JSON.parse(localStorage.getItem('user'));

            this.questions.forEach( q => {
                if(this.answers[q.id] == undefined || this.answers[q.id] == null ){
                    this.answers[`${q.id}`] = -1;
                }
            });


            let evaluation = { 
                answers : this.answers,
                questions : this.questions
            }

            let eval_uri = `${config.serviceUri}evaluations?userId=${user.id}&examId=${this.exam_id}`;
            eval_uri = user.id_relInst ? `${config.serviceUri}evaluations?userId=${user.id}&examId=${this.exam_id}&relInst=${user.id_relInst}` : eval_uri;
            this.axios.post(eval_uri, evaluation )
            .then( (response) => {
                console.log('Results Ready: ',response.data);
                this.loading = false;
            })
            .catch( (error) => {
                console.log('Error: ', error);
                this.loading = false;
            });

        },
        finalize(){
            this.saveResults();
            setTimeout(() => this.$router.push({ name: 'home' }), 1000);
        }
    }
}
</script>

<style scoped>
.timer{
    margin: 6.5% 2% 0 0;
    width: 300px;
    max-width: 20%;
    max-height: 25%;
    background: #ffffff;
    position: fixed;
    right: 0;
    top: 0;
/* 
    -webkit-box-shadow: -2px 10px 33px -3px rgba(0,0,0,0.75);
    -moz-box-shadow: -2px 10px 33px -3px rgba(0,0,0,0.75);
    box-shadow: -2px 10px 33px -3px rgba(0,0,0,0.75); */
}

.exam-container{
    width: 60%;
    margin: 5% 20%;
    padding: 40px;
    background: #ffffff;
    
}
.intructions{
    width: 60%;
    margin: auto auto;
    background: #ffffff;
}

.text-warn{
    text-align: center;
    color: black;
    font-size: 1rem;
}

.init-dialog .v-overlay__scrim{
    background: green !important;
}

.advance{
    width: 100%;
    text-align: center;
    justify-content: center;
}
.navexams-btn-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.navexams-btn-container .col{
    flex: 1;

    padding: 0;
    display: flex;
    justify-content: center;
    
}
.navexams-btn{
    flex: 1;
    margin: 0 8%;

}
</style>
